import React, { Component } from "react";
// core components
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import _ from "lodash";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {
  ErrorOutline,
  Store,
  Bookmarks,
  DateRangeOutlined,
} from "@material-ui/icons";
const styles = (theme) => ({
  cardText: {
    fontWeight: 500,
    textAlign: "end",
  },
  cardTitle: {
    fontSize: "20px",
  },
  cardInfo: {
    fontSize: "30px",
    paddingRight: "20px",
  },
  cardUpdateInfo: {
    fontSize: "13px",
    color: "grey",
    margin: 0,
    padding: 0,
  },
  iconBox: {
    width: "75px",
    height: "75px",
    borderRadius: "5px",
    position: "absolute",
    marginTop: "-50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  bgBox1: {
    backgroundColor: "#fd950e",
  },
  bgBox2: {
    backgroundColor: "#4ba34f",
  },
  bgBox3: {
    backgroundColor: "#e63d36",
  },
});

class StatusCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      datatable: [],
      selectedCategory: "",
      selectedCategoryPeriode: "30",
      catspeed: [],
      date: moment().format("DD/MM/YYYY")
    };
  }

  UNSAFE_componentWillMount() {
    let date = new Date();

    this.setState({
      date: moment(date).format("DD/MM/YYYY")
    });
  }
  render() {
    const { classes } = this.props;
    return (
      <Grid item xs={12} md={6} lg={3}>
        <Card>
          <CardContent>
            <Grid container>
              <Grid item xs={4}>
                <div
                  className={`${classes.iconBox} ${
                    this.props.option === 1
                      ? classes.bgBox1
                      : this.props.option === 2
                        ? classes.bgBox2
                        : classes.bgBox3
                  }`}
                >
                  {this.props.option === 1 ? (
                    <Bookmarks style={{ color: "#FFFFFF" }} fontSize="large" />
                  ) : this.props.option === 2 ? (
                    <Store style={{ color: "#FFFFFF" }} fontSize="large" />
                  ) : (
                    <ErrorOutline
                      style={{ color: "#FFFFFF" }}
                      fontSize="large"
                    />
                  )}
                </div>
              </Grid>
              <Grid item xs={8}>
                <p className={`${classes.cardTitle} ${classes.cardText}`}>
                  {this.props.title}
                </p>
                <p className={`${classes.cardInfo} ${classes.cardText}`}>
                  {this.props.total} Fleets
                </p>
              </Grid>
            </Grid>
            <hr />
            <p className={classes.cardUpdateInfo}>
              <span>
                <DateRangeOutlined style={{ fontSize: "13px" }} />
              </span>{" "}
              last update {this.state.date}
            </p>
          </CardContent>
        </Card>
      </Grid>
    );
  }
}

export default withStyles(styles)(StatusCard);
